import { memo } from 'react';
import { alpha, Chip, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IUserMfa } from 'modules/security/users/interfaces/IUser';

type UserMfaCellProps = {
  mfa?: IUserMfa;
};

const UserMfaCell = ({ mfa }: UserMfaCellProps) => {
  const { t } = useTranslation(['users', 'authentication']);
  const isEnabled = mfa?.enabled === true;
  // A user has at most one primary method, but the backend models it as an array.
  const method = mfa?.methods?.[0];

  return (
    <Stack direction='row' spacing={1} alignItems='center' flexWrap='wrap'>
      <Chip
        size='small'
        label={t(isEnabled ? 'users:mfa.enabled' : 'users:mfa.disabled')}
        sx={{
          height: 22,
          fontWeight: 600,
          color: isEnabled ? 'success.main' : 'error.main',
          bgcolor: ({ palette }) => alpha(isEnabled ? palette.success.main : palette.error.main, 0.12),
        }}
      />
      {isEnabled && method && (
        <Typography variant='body2' color='text.secondary'>
          {t(`authentication:mfa.methods.${method}`)}
        </Typography>
      )}
    </Stack>
  );
};

export default memo(UserMfaCell);
